module.exports = __webpack_public_path__ + "img/retainerdesk_analytics.f255db56.png";